(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('BankAccountInfoSearch', BankAccountInfoSearch);

    BankAccountInfoSearch.$inject = ['$resource'];

    function BankAccountInfoSearch($resource) {
        var resourceUrl = 'api/_search/bank-account-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
